import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";

function SendReminderModal({ t, modalShow, dce, callbackModal }) {
	const [show, setShow] = useState(modalShow);
	const [dataOwners, setDataOwners] = useState(false);
	const [selectedApproverLevels, setSelectedApproverLevels] = useState([]);
	const [selectAll, setSelectAll] = useState(false);

	const isReviewRequired = dce?.assessmentForm?.reviewRequired === true;

	useEffect(() => {
		setShow(modalShow);
		if (!modalShow) {
			// Reset state when modal closes
			setDataOwners(false);
			setSelectedApproverLevels([]);
			setSelectAll(false);
		}
	}, [modalShow]);

	useEffect(() => {
		// Update selectAll based on individual checkboxes
		const allSelected = 
			dataOwners &&
			selectedApproverLevels.includes(1) &&
			selectedApproverLevels.includes(2) &&
			selectedApproverLevels.includes(3);
		setSelectAll(allSelected);
	}, [dataOwners, selectedApproverLevels]);

	const handleClose = () => {
		setShow(false);
		callbackModal(false, null);
	};

	const handleConfirm = () => {
		setShow(false);
		const payload = isReviewRequired ? {
			dataOwners: dataOwners,
			selectedApproverLevels: selectedApproverLevels
		} : null;
		callbackModal(true, payload);
	};

	const handleSelectAll = (checked) => {
		setSelectAll(checked);
		setDataOwners(checked);
		if (checked) {
			setSelectedApproverLevels([1, 2, 3]);
		} else {
			setSelectedApproverLevels([]);
		}
	};

	const handleDataOwnersChange = (checked) => {
		setDataOwners(checked);
	};

	const handleApproverLevelChange = (level, checked) => {
		if (checked) {
			setSelectedApproverLevels(prev => [...prev, level]);
		} else {
			setSelectedApproverLevels(prev => prev.filter(l => l !== level));
		}
	};

	const canConfirm = () => {
		if (!isReviewRequired) return true;
		return dataOwners || selectedApproverLevels.length > 0;
	};

	return (
		<Modal 
			show={show} 
			onHide={handleClose}
			aria-labelledby="contained-modal-title-vcenter"
			centered 
			backdrop="static"
			keyboard={false}
		>
			<Modal.Header className="border-0" closeButton>
				<Modal.Title as="h5">{t('SendReminder2.label')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{isReviewRequired ? (
					<div>
						<p className="mb-3">{t('SendReminderToDCEReviewers.label')}</p>
						<div className="mb-3">
							<Form.Check
								type="checkbox"
								id="selectAll"
								label={t('SelectAll.label')}
								checked={selectAll}
								onChange={(e) => handleSelectAll(e.target.checked)}
							/>
						</div>
						<div className="ms-3">
							<Form.Check
								type="checkbox"
								id="dataOwners"
								label={t('DataOwners.label')}
								checked={dataOwners}
								onChange={(e) => handleDataOwnersChange(e.target.checked)}
							/>
							<Form.Check
								type="checkbox"
								id="firstLevelApprovers"
								label={t('FirstLevelApprovers.label')}
								checked={selectedApproverLevels.includes(1)}
								onChange={(e) => handleApproverLevelChange(1, e.target.checked)}
							/>
							<Form.Check
								type="checkbox"
								id="secondLevelApprovers"
								label={t('SecondLevelApprovers.label')}
								checked={selectedApproverLevels.includes(2)}
								onChange={(e) => handleApproverLevelChange(2, e.target.checked)}
							/>
							<Form.Check
								type="checkbox"
								id="thirdLevelApprovers"
								label={t('ThirdLevelApprovers.label')}
								checked={selectedApproverLevels.includes(3)}
								onChange={(e) => handleApproverLevelChange(3, e.target.checked)}
							/>
						</div>
					</div>
				) : (
					<div className="d-flex align-items-center justify-content-center shortDataHeight">
						{t('QuickSendReminderConfirmation.label')}
					</div>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" className="px-3" onClick={handleClose} autoFocus>
					{t("No.label")}
				</Button>
				<Button 
					variant="primary" 
					onClick={handleConfirm} 
					className="px-3"
					disabled={!canConfirm()}
				>
					{t("Yes.label")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default withTranslation()(SendReminderModal);

